<template>
    <label class="sn-checkbox">
        <input :checked="value" type="checkbox" @input="$emit('input', $event.target.checked)">
        <span class="checkmark"/>
        <slot>
            <span v-html="label"/>
        </slot>
    </label>
</template>

<script>
export default {
    name: "SnCheckbox",
    props: {
        value: {
            type: Boolean,
            required: true
        },
        label: {
            type: String,
            required: false
        }
    }
}
</script>

<style scoped lang="scss">
    /* The container */
    .sn-checkbox {
        display: block;
        position: relative;
        padding-left: 40px;
        cursor: pointer;
        font-size: 16px;
        line-height: 27px;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }

    /* Hide the browser's default checkbox */
    .sn-checkbox input {
        position: absolute;
        opacity: 0;
        cursor: pointer;
        height: 0 !important;
        width: 0 !important;
    }

    /* Create a custom checkbox */
    .checkmark {
        position: absolute;
        top: 0;
        left: 0;
        height: 25px;
        width: 25px;
        background-color: #fff;
        border: 1px solid #2e2e2e;
    }

    /* On mouse-over, add a grey background color */
    .sn-checkbox:hover input ~ .checkmark {
        background-color: #fff;
    }

    /* When the checkbox is checked, add a blue background */
    .sn-checkbox input:checked ~ .checkmark {
        background-color: #5f6a7b;
        border-color: #5f6a7b;
        border-radius: 4px;
    }

    /* Create the checkmark/indicator (hidden when not checked) */
    .checkmark:after {
        content: "";
        position: absolute;
        display: none;
    }

    /* Show the checkmark when checked */
    .sn-checkbox input:checked ~ .checkmark:after {
        display: block;
    }

    /* Style the checkmark/indicator */
    .sn-checkbox .checkmark:after {
        left: 8px;
        top: 3px;
        width: 6px;
        height: 12px;
        border: solid white;
        border-width: 0 4px 4px 0;
        -webkit-transform: rotate(45deg);
        -ms-transform: rotate(45deg);
        transform: rotate(45deg);
    }
</style>